import API from "components/Apis/API"

export const getFormattedDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export const fetchSummaryData = async (setSummaryData) => {
  const url = "" + "admin/get_dashboard_summary"
  const data = await API.postData(url)
  setSummaryData(data)
}

export const fetchLineData = async (setLineData) => {
  const url = "" + "admin/get_dashboard_linegraph"
  const data = await API.postData(url)
  setLineData(data.line_data)
}

export const fetchPickupHeatmapData = async (setPickupHeatmapData, startDate, endDate) => {
  const url = "admin/get_pickup_heatmap"
  const formData = new FormData();
  formData.append('startDate', startDate);
  formData.append('endDate', endDate);
  const data = await API.postData(url, formData)
  setPickupHeatmapData(Object.values(data))
}

export const fetchMxBorderCrossKPIs = async (setMxBorderKPIs, startDate, endDate) => {
  const url = "admin/get_mx_cross_time_kpi"
  const formData = new FormData();
  formData.append('startDate', startDate);
  formData.append('endDate', endDate);
  const data = await API.postData(url, formData)
  setMxBorderKPIs(data)
}

export const getTitle = (title) => {
  if (title === "ckv") {
    return "Clarksville"
  } else if (title === "lrd") {
    return "Laredo"
  } else {
    return "Taylor"
  }
}

export const getMargin = (title) => {
  if (title === "lrd") {
    return "mb-2"
  } else if (title === "ckv") {
    return "my-2"
  } else {
    return "mt-2"
  }
}

export const getBarNumber = (data, section) => {
  const LRD = data.lrd[section]
  const CKV = data.ckv[section]
  const DTW = data.dtw[section]
  return {
    data: { LRD, DTW, CKV },
    labels: ["LRD", "DTW", "CKV"],
  }
}

function getColorFromClass(className) {
  // gets color from css class
  // Create a temporary element
  const tempElement = document.createElement('div');
  // Add the class to the element
  tempElement.className = className;
  // Append the element to the body (it won't be visible)
  document.body.appendChild(tempElement);
  // Get the computed style of the element
  const color = window.getComputedStyle(tempElement).color;
  // Remove the element from the body
  document.body.removeChild(tempElement);
  // Return the color
  return color;
};

export const getGraphColor = (terminal) => {
  return getColorFromClass(terminal.toLowerCase());
};

export function appendGraphColours(data) {
  data.datasets.map((terminal) => {
      terminal.backgroundColor = getGraphColor(terminal.label);
      terminal.borderColor = getGraphColor(terminal.label);
  });
  return data
}

export function rgbaToRgb(rgba) {
  // Extract the rgba values using a regular expression
  const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*(\d*\.?\d+)?\)/);

  if (!match) {
      throw new Error("Invalid RGBA format");
  }

  const r = match[1];
  const g = match[2];
  const b = match[3];

  // Return the rgb string
  return `rgb(${r}, ${g}, ${b})`;
}

export function rgbaToHex(rgba) {
  const rgbaValues = rgba.match(/\d+/g).map(Number);
  const [r, g, b, a] = rgbaValues;

  const toHex = (n) => {
      const hex = n.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
  };

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function rgbToRgba(rgb, a) {
  // Extract the r, g, b values using a regular expression
  const match = rgb.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (!match) {
      throw new Error("Invalid RGB format");
  }
  const r = match[1];
  const g = match[2];
  const b = match[3];
  // Ensure the alpha value is valid
  if (a < 0 || a > 1) {
      throw new Error("Alpha value must be between 0 and 1");
  }
  // Return the rgba string
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function getDeltaMonthFormatedDate(deltaMonth) {
  // Get today's date
  const today = new Date();
  // Subtract three months
  today.setMonth(today.getMonth() - deltaMonth);
  // Format the date in YYYY-MM-DD format
  const formattedDate = today.toISOString().split('T')[0];
  return formattedDate;
}

export function getTodaysFormatedDate() {
  // Get today's date in YYYY-MM-DD format
  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];
  return formattedToday
}

export function convertMinutesToHoursAndMinutes(totalMinutes) {
  // Round the input to the nearest whole minute
  const roundedMinutes = Math.round(totalMinutes);
  
  // Calculate hours and remaining minutes
  const hours = Math.floor(roundedMinutes / 60);
  const minutes = roundedMinutes % 60;

  // Return the result in "hours:minutes" format
  return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}
